import { render } from "./GoalScoringDistribution.vue?vue&type=template&id=7bd6b9d4&scoped=true"
import script from "./GoalScoringDistribution.vue?vue&type=script&lang=js"
export * from "./GoalScoringDistribution.vue?vue&type=script&lang=js"

import "./GoalScoringDistribution.vue?vue&type=style&index=0&id=7bd6b9d4&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bd6b9d4"]])

export default __exports__